// extracted by css-extract-rspack-plugin
export default {"cardContent":"ManagerApproveBatchModal_cardContent__UlDXE"};